// extracted by mini-css-extract-plugin
module.exports = {"map":"map-1EW7q"};